import {StrictMode} from "react";
import {render} from "react-dom";
import App from "./App";

import "@fontsource/rubik";
import {ChakraProvider} from "@chakra-ui/react";
import theme from "lib/theme";

render(
    <StrictMode>
        <ChakraProvider theme={theme}>
            <App />
        </ChakraProvider>
    </StrictMode>,
    document.querySelector("#root"),
);
